import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import { observer, inject } from 'mobx-react'
import { deepClone, enumToView } from '@src/utils';
import * as styles from './style/index.scss'
import { WhiteSpace, Button, Checkbox } from 'antd-mobile'
import { FormattedMessage } from 'react-intl'
import intl from '@utils/intl';
import MultiActivity from '@utils/multiActivity'
import BasePackageInfo from './cmp/basePackageInfo'
import ExpansionPackageInfo from './cmp/expansionPackageInfo'
import VeritcalLineTitle from '@componentsG/veritcalLineTitle'
import { userStore } from '@src/store/userStore'
import { TRYBUY_EVENT_TRACING_CLICK } from '@src/constants'
import { filterFlowUnit } from '@utils/index';

const AgreeItem = Checkbox.AgreeItem;

@inject('orderStore', 'homeStoreG')
@observer
class PackageDetail extends ComponentExt<any, any> {
    private store: any
    private homeStoreG: any
    private params: any
    private readonly userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}

    constructor(props) {
        super(props)
        this.store = props.orderStore
        this.homeStoreG = props.homeStoreG
        this.params = props.match.params
        this.state = {
            checked: false
        }
    }

    async componentDidMount() {
        this.showLoading()
        // 如果是加油包，调接口获取当前套餐信息
        if (this.params.type === '1') {
            await this.homeStoreG.getSimInfo(this.userInfo.iccid)
        }
        await this.store[this.params.type === '0' ? 'getPackageDetail' : 'getRefuelPackageDetail'](this.params.goodsReleaseId, this.userInfo.iccid, this.params.countryCode, this.params.cargoType, this.params.activityId)
        this.hideLoading()
    }

    changeCheckBox = e => {
        this.setState({
            checked: e.target.checked
        })
    }

    handlePay = (goodsReleaseId) => {
        const activityId = this.params.activityId ? this.params.activityId : ''
        this.goToPath(`/global/billAddress/${this.params.countryCode}/${this.params.countryName}/${this.params.type}/${goodsReleaseId}/${this.params.cargoType}/${activityId}`)
        const packageDetail = deepClone(this.store.packageDetail)
        const obj = {
            '0': `${filterFlowUnit(packageDetail.policyDegree)}-${packageDetail.timeLength}${packageDetail.timeUnit === '1' ? '天' : '月'}`, // 基础包
            '1': filterFlowUnit(packageDetail.policyDegree), // 加油包
        }
        userStore.sendEventTracing({
            pageCode: '',
            buttonCode: TRYBUY_EVENT_TRACING_CLICK[this.params.type === '0' ? 'TRYBUY_ORDER_BASE_PACKAGE' : 'TRYBUY_ORDER_ADD_PACKAGE'],
            buttonInfo: obj[this.params.type]
        })
    }

    render() {
        const packageDetail = deepClone(this.store.packageDetail)
        const currentPackage = deepClone(this.homeStoreG.simInfo)
        if (JSON.stringify(packageDetail) === '{}') {
            return <></>
        }
        const multiActivity = new MultiActivity(packageDetail)
        const preMonth = intl.formatMessage({ id: 'common.unitMonthOdd' })
        return (
            <div className={styles.packageDetail}>
                {
                    this.params.type === '0' ?
                        <BasePackageInfo
                            packageDetail={packageDetail}
                            preMonth={preMonth}
                        /> :
                        <ExpansionPackageInfo currentPackageInfo={currentPackage} expansionDetail={packageDetail} />
                }
                <WhiteSpace className={styles.whiteSpace} />
                {/*套餐说明*/}
                <div className={styles.packageIntro}>
                    <VeritcalLineTitle messageId="packageDetail.description" />
                    {
                        packageDetail.infoLists.map((item, index) =>
                            <p key={index} className={styles.introItem}>{item}</p>
                        )
                    }
                </div>
                {/*底部支付信息*/}
                <div className={styles.payInfoWrap} >
                    <div className={styles.flexItem} style={{ marginTop: 0 }}>
                        <span className={styles.itemKey}>
                            <FormattedMessage id="order.item.subTotal" />:</span>
                        <span className={styles.itemValue}>{enumToView('CURRENCY', packageDetail.cargoType)}
                            {packageDetail.releasePrice}
                        </span>
                    </div>
                    <div className={styles.flexItem}>
                        <span className={styles.itemKey}>
                            <FormattedMessage id="order.item.vat" />
                            {`(${Number(packageDetail.vat * 100)}%):`}
                        </span>
                        <span className={styles.itemValue}>
                            {enumToView('CURRENCY', packageDetail.cargoType)}
                            {packageDetail.vatPrice}</span>
                    </div>
                    <div className={styles.flexItem}>
                        <span className={styles.totalKey}>
                            <FormattedMessage id="order.item.totalFee" />:
                        </span>
                        <p className={styles.totalValue}>
                            {multiActivity.hasEffectiveActivity() &&
                                <span className={styles.oldPrice}>{enumToView('CURRENCY', packageDetail.cargoType)}{packageDetail.beforePrice}</span>
                            }
                            <span>{enumToView('CURRENCY', packageDetail.cargoType)}{packageDetail.totalPrice}</span>
                        </p>
                    </div>
                    <AgreeItem onChange={this.changeCheckBox}>
                        {localStorage.getItem('chl') === 'tabletApp' ?
                            <FormattedMessage
                                id="packageDetail.privacyForTablet"
                                values={{
                                    a: chunks => <span
                                        style={{ color: '#eb6a1a', fontWeight: 'bold' }}
                                        onClick={(e) => {
                                            e.preventDefault()
                                            window.open('https://www.ckh.com.hk/en/global/tnc.php')
                                        }}
                                    >{chunks}
                                    </span>,
                                    b: chunks => <span
                                        style={{ color: '#eb6a1a', fontWeight: 'bold' }}
                                        onClick={(e) => {
                                            e.preventDefault()
                                            window.open('https://www.ckh.com.hk/en/global/privacy.php')
                                        }}
                                    >{chunks}
                                    </span>
                                }}
                            />
                            :
                            <>
                                <FormattedMessage
                                    id="packageDetail.privacy"
                                    values={{
                                        a: chunks => <span
                                            style={{ color: '#eb6a1a', fontWeight: 'bold' }}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                window.open('https://www.truphone.com/legal/truphone-esim-terms-and-conditions/')
                                            }}
                                        >
                                            {chunks}
                                        </span>,
                                        b: chunks => <span
                                            style={{ color: '#eb6a1a', fontWeight: 'bold' }}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                window.open('https://www.truphone.com/legal/privacy-policy/')
                                            }}
                                        >
                                            {chunks}
                                        </span>
                                    }}
                                />
                                Lenovo Connect Powered by Truphone
                            </>
                        }
                    </AgreeItem>
                </div>
                <Button
                    className={styles.btn}
                    disabled={!this.state.checked}
                    onClick={() => this.handlePay(packageDetail.goodsReleaseId)}
                >
                    <FormattedMessage id="packageDetail.payBtn.text" />
                </Button>
            </div>
        )
    }
}

export default PackageDetail
